<template>
  <div>
    <loading v-if="cargando" />
    <NavBarTop v-if="this.$store.state.auth" />
    <NavBarLeft v-show="this.$store.state.auth" />
    <div class="text-xs sidebar-mini-xs" :class="darkMode ? 'dark-mode' : ''">
      <transition name="fade-slide-right" mode="out-in">
        <router-view />
      </transition>
    </div>
    <ContentWrapper />
    <vue-progress-bar />
  </div>
</template>
<script>
import NavBarTop from "./components/layout/NavBarTop";
import NavBarLeft from "./components/layout/NavBarLeft";
import ContentWrapper from "./components/layout/ContentWrapper";
import Loading from "./components/LoadingSpinner";
import { redireccionInicio, rutaInicio } from './services/pedidosCliente';

export default {
  components: {
    NavBarTop,
    NavBarLeft,
    ContentWrapper,
    Loading,
  },

  data() {
    return {
      darkMode: false,
      cargando: false,
    };
  },

  created() {
    this.$Progress.start();
    this.cargando = true;
    this.$router.beforeEach((to, from, next) => {
      if (to.meta.progress !== undefined) {
        let meta = to.meta.progress;
        this.$Progress.parseMeta(meta);
      }
      this.$Progress.start();
      this.cargando = true;
      next();
    });
    this.$router.afterEach(() => {
      this.$Progress.finish();
      this.cargando = false;
    });
  },

  methods: {
    darkModeChange(dato) {
      this.darkMode = dato;
      this.$store.dispatch("setDarkMode", dato);
    },
  },

  async mounted() {
    await this.$store.dispatch("getUser");
    await this.$store.dispatch("getMenus");
    await this.$store.dispatch("getPermissions");
    await this.$store.dispatch("getRoutes", this.$store.getters.getMenus);
    await this.$store.dispatch("setRoutes");
    if (
      this.$store.getters.isAuthenticated &&
      (this.$route.name === "LoginForm" || redireccionInicio(this.$route, this.$store.getters.getUser))
    ) {
      return this.$router.replace(rutaInicio(this.$store.getters.getUser));
    }
    await this.$Progress.finish();
    this.cargando = false;
  },
};
</script>

<style>
.bg-hemolife {
  background: linear-gradient(to bottom, #e53538, #4e6990);
}
.bg-hemolife-rs {
  background: linear-gradient(to bottom, #e53538, #4e6990);
}

.bg-hemolife-rg {
  background: radial-gradient(closest-side, #4e6990, #e53538);
}

.bg-hemolife-red {
  background: #e53538;
}
.bg-hemolife-blue {
  background: #4e6990;
}

.bg-hemolife-top-left {
  background: linear-gradient(to bottom, #e53538, #4e6990);
}

.fade-slide-right-enter-active {
  transition: all 0.5s ease;
}
.fade-slide-right-leave-active {
  transition: all 0.5s ease;
}
.fade-slide-right-enter,
.fade-slide-right-leave-to {
  transform: translateX(5%);
  opacity: 0;
}

.dark-vselect .vs__search::placeholder,
.dark-vselect .vs__dropdown-toggle,
.dark-vselect .vs__dropdown-menu,
.dark-vselect .vs__dropdown-option {
  background: #343a40;
  border: solid 1px #535b62;
  color: #fff;
  text-transform: lowercase;
  font-variant: small-caps;
}

.dark-vselect .vs__selected-options,
.dark-vselect .vs__selected,
.dark-vselect .vs__search,
.dark-vselect .vs__open {
  color: #fff;
}
.dark-vselect .vs__selected {
  background: #454d55;
}

.dark-vselect .vs__dropdown-option:hover {
  background: rgb(0, 4, 63);
}

.dark-vselect .vs__clear,
.dark-vselect .vs__open-indicator,
.dark-vselect .vs__deselect {
  fill: #fff;
}

.vs--disabled .vs__clear,
.vs--disabled .vs__dropdown-toggle,
.vs--disabled .vs__open-indicator,
.vs--disabled .vs__search,
.vs--disabled .vs__selected {
  background: #b7b5b5 !important;
}

.vs__selected-options {
  flex-wrap: nowrap;
  max-width: calc(100%);
}

.vs__selected {
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
  overflow: hidden;
}

.error-vselect .vs__dropdown-toggle {
  border: solid thin #4e6990;
}
.ok-vselect .vs__dropdown-toggle {
  border: solid thin #e53538;
}

/* ========== Hemolife — contenido: cards, tablas, migas (todas las vistas) ========== */
.wrapper .content-wrapper {
  background: #f0f4fa;
}

.content-wrapper .content-header h1,
.content-wrapper .content-header h5 {
  color: #1e293b;
  font-weight: 600;
  letter-spacing: -0.01em;
}

.content-wrapper .breadcrumb {
  background: transparent;
  padding: 0.35rem 0;
  margin-bottom: 0;
}

.content-wrapper .breadcrumb-item + .breadcrumb-item::before {
  color: #94a3b8;
}

.content-wrapper .breadcrumb-item.active {
  color: #4e6990;
  font-weight: 500;
}

.content-wrapper .card {
  border-radius: 12px;
  border: 1px solid rgba(78, 105, 144, 0.12);
  box-shadow: 0 4px 22px rgba(15, 23, 42, 0.06);
  /* visible: si no, vue-select / dropdowns en card-header quedan recortados */
  overflow: visible;
}

.content-wrapper .card > .card-body {
  border-radius: 0 0 11px 11px;
  overflow: hidden;
}

/* v-select: menú por encima de tablas y bordes de card */
.content-wrapper .vs__dropdown-menu {
  z-index: 2005 !important;
}

.content-wrapper .card-header {
  background: linear-gradient(
    135deg,
    rgba(78, 105, 144, 0.08),
    rgba(229, 53, 56, 0.05)
  );
  border-bottom: 1px solid rgba(78, 105, 144, 0.1);
}

.content-wrapper .table thead th {
  background: linear-gradient(180deg, #b0c4dc 0%, #9eb4d0 100%);
  color: #0f172a;
  font-weight: 600;
  font-size: 0.8125rem;
  border-color: #8aa0bc;
  vertical-align: middle;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.35);
}

/* Tablas con thead oscuro (AdminLTE bg-navy): encabezado más visible que el gris tenue */
.content-wrapper .table thead.bg-navy th {
  background: linear-gradient(180deg, #3d5d82 0%, #2f4a6e 100%) !important;
  color: #fff !important;
  border-color: rgba(255, 255, 255, 0.22) !important;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
}

.content-wrapper .table-bordered th,
.content-wrapper .table-bordered td {
  border-color: #e2e8f0;
}

.content-wrapper .table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(78, 105, 144, 0.035);
}

.content-wrapper .table-hover tbody tr:hover {
  background-color: rgba(229, 53, 56, 0.055);
}

.main-footer {
  border-top: 1px solid rgba(78, 105, 144, 0.12);
  background: #fff;
  color: #64748b;
  font-size: 0.875rem;
}
</style>

